var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDetailsArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.70953 6.10833C4.74324 6.49355 5.07501 6.73625 5.44266 6.72349L9.95729 6.19265L4.89534 12.2253C4.66685 12.4976 4.70392 12.9213 4.97623 13.1498L5.64651 13.7122C5.93977 13.9583 6.34257 13.9037 6.57106 13.6314L11.633 7.59875L11.9151 12.1545C11.9664 12.5188 12.263 12.8034 12.6483 12.7697L13.4958 12.6956C13.8425 12.6652 14.1237 12.3301 14.0934 11.9834L13.4186 4.4924C13.4058 4.12474 13.0916 3.8611 12.7064 3.8948L5.23298 4.54864C4.88627 4.57898 4.62263 4.89317 4.63539 5.26083L4.70953 6.10833Z",
    fill: "#E7E5E4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailsArrow);
export default __webpack_public_path__ + "static/media/details_arrow.d4add7df043195d5c661b2cbde342207.svg";
export { ForwardRef as ReactComponent };